import React, { useRef } from "react";

import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import BuyWearReturnRepeatAlt from "./BuyWearReturnRepeatAlt";
import HeadingLarge from "./HeadingLarge";
import Image from "./Image";
import IndentedParagraphMedium from "./IndentedParagraphMedium";
import LottieOnEntered from "./LottieOnEntered";
import { Player } from "./Player";
import PropTypes from "prop-types";
import diagramAnimData from "../assets/takeback-diagram.json";
import diagramAnimDataMobile from "../assets/takeback-diagram-mobile.json";

function TakebackHero({ heading, subheading, heroImage }) {
  const playerRef = useRef();
  return (
    <>
      <Box pt={[100, null, 120, null]} bg="yellow">
        <BoxWithGutter pb={[45, "calc(12.5% + 30px)", null, null]}>
          <HeadingLarge uppercase>{heading}</HeadingLarge>
          <Box pt={[45, null, 60, null]}>
            <IndentedParagraphMedium>{subheading}</IndentedParagraphMedium>
          </Box>
        </BoxWithGutter>
      </Box>
      <Box
        display={["none", "block", null, null]}
        my="-12.5%"
        pb="12.5%"
        bg="yellow"
      >
        <Box
          position="relative"
          width="100%"
          mx="auto"
          zIndex={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box bg="yellow" height="75%" width="100%" position="absolute">
            {heroImage && (
              <Image
                src={heroImage.url}
                alt={heroImage.title}
                objectFit="cover"
              />
            )}
          </Box>
          <BoxWithGutter>
            <LottieOnEntered src={diagramAnimData} threshold={0.5} />
            <BuyWearReturnRepeatAlt />
          </BoxWithGutter>
        </Box>
      </Box>
      <Box
        display={["flex", "none", null, null]}
        height={450}
        alignItems="center"
        justifyContent="center"
        position="relative"
        bg="yellow"
      >
        {heroImage && (
          <Box height="100%" width="100%" top={0} left={0} position="absolute">
            <Image
              src={heroImage.url}
              alt={heroImage.title}
              objectFit="cover"
              objectPosition="0% 0%"
            />
          </Box>
        )}
        <Box height={225} position="relative" zIndex={3}>
          <Player
            ref={playerRef}
            src={diagramAnimDataMobile}
            loop={true}
            autoplay={true}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid meet",
            }}
          />
        </Box>
        <Box
          position="absolute"
          height="100%"
          width="100%"
          top={0}
          left={0}
          zIndex={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            height={325}
            width={325}
            border="2px solid black"
            borderRadius="100%"
            bg="mushroom"
            p="5px"
          >
            <Box position="relative" height="100%" width="100%">
              <BuyWearReturnRepeatAlt />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default TakebackHero;

TakebackHero.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  heroImage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
};
